import {inject, Injectable} from "@angular/core";
import {MainHttpService} from "./main-http.service";
import {firstValueFrom} from "rxjs";


@Injectable({
  providedIn: 'root',
})
export class NewsService {
  #http = inject(MainHttpService);

  async newsList(data: { paging: { page: number, size: number } }): Promise<any> {
    const response$ = this.#http.post<any, { paging: { page: number, size: number } }>('news/list', data);
    return firstValueFrom(response$)
  }

  async newsOne(data: { uuid: string }): Promise<any> {
    const response$ = this.#http.post<any, { uuid: string }>('news/one', data);
    return firstValueFrom(response$)
  }

}
